function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhotoButtonMark1 = function SvgPhotoButtonMark1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 87.438 87.375"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M212.1 959.562a43.7 43.7 0 1 1 43.706-43.7 43.7 43.7 0 0 1-43.706 43.7m0-85.205a41.51 41.51 0 1 0 41.52 41.51 41.515 41.515 0 0 0-41.52-41.51m18.9 53.526h-37.811a1.84 1.84 0 0 1-1.854-1.825v-20.153a1.84 1.84 0 0 1 1.854-1.826h1.411a1.26 1.26 0 0 1 1.112-.657h3.559a1.26 1.26 0 0 1 1.112.657h1.917l1.418-2.3a3.26 3.26 0 0 1 2.6-1.205h11.493a3.26 3.26 0 0 1 2.6 1.205l1.418 2.3H231a1.84 1.84 0 0 1 1.854 1.826v20.153a1.84 1.84 0 0 1-1.854 1.825m-18.9-22.125a10.224 10.224 0 1 0 10.38 10.223 10.3 10.3 0 0 0-10.38-10.223m0 18.182a7.96 7.96 0 1 1 8.081-7.959 8.02 8.02 0 0 1-8.081 7.959",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    transform: "translate(-168.375 -872.188)"
  }));
};
export default SvgPhotoButtonMark1;